export  const selectMixin = {
  created: function () {
   // this.getID();
  },
  methods: {
    getID (data) {
      if (data){
        return data.id;
      }
    },
    setSelectedOptionsByID (options,data) {
      return data ? options.filter(item => item.id == data)[0] : '' ;
    }
  }
}